import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/** Página que pode ter alterações locais ainda não confirmadas. */
export interface HasUnconfirmedChanges {
  /** true = pode sair; Observable = pergunta ao usuário antes. */
  canLeave(): boolean | Observable<boolean>;
}

/** Caminho sem query string nem fragmento: "/a/b?tab=anexos#x" → "/a/b". */
const pathOf = (url: string | undefined): string => (url ?? '').split(/[?#]/)[0];

/**
 * Pergunta antes de sair de uma página com revisão não confirmada (botão voltar, menu lateral,
 * breadcrumb, voltar do navegador). Fechar ou recarregar a aba é tratado pelo beforeunload da página.
 * Navegações que ficam na mesma página (ex.: trocar de aba, que muda só ?tab=) não perguntam.
 */
export const unconfirmedReviewGuard: CanDeactivateFn<HasUnconfirmedChanges> = (
  component,
  _currentRoute,
  currentState,
  nextState
) => {
  if (nextState && currentState && pathOf(nextState.url) === pathOf(currentState.url)) {
    return true;
  }
  return component?.canLeave ? component.canLeave() : true;
};
